// @ts-nocheck
'use strict';
import $ from 'jquery';
import { getCookie } from '../base/utils/get_cookie.js';

function setUpUI(){

  $(".academy_tr").each(function(){
    $(this).addClass("hidden");
  });
  $(".div_1").each(function(){
    $(this).removeClass("hidden");
  });

  $(".ico-pin").on('click', function(){
    let div_code = $(this).attr("data-div-code")
    let div_name = $(this).attr("data-div-name")
    $("#div_name").text(div_name)
    // console.log(div_code)
    $(".academy_tr").each(function(){
      $(this).addClass("hidden");
    });
    $("."+div_code).each(function(){
      $(this).removeClass("hidden");
    });
  });

  $(".div_click").on('click', function(){
    console.log(this);
  });


  

}

setUpUI();
